import TagsView from "@/components/TagsView/tagsView.component";
import BasePage from "@/infrastructure/BasePage/basePage.component";
import { Card } from "@/shadcn/components/ui/card";

type TagsPageProps = {
  // TODO: add props here
};

const TagsPage: React.FC<TagsPageProps> = (props) => {
  return (
    <BasePage currPage="tags">
      <Card className="flex flex-col w-full h-full rounded-sm dark:bg-background">
        <TagsView />
      </Card>
    </BasePage>
  );
};

export default TagsPage;
